
define('app/ko-app',['jquery',
        'knockout',
        'eteration/eteration-base',
        'eteration/eteration-ajax',
        'eteration/ui/form-viewmodel',
        'eteration/ui/signup-viewmodel',
        'eteration/ui/userpref-viewmodel',
        'eteration/ui/login-viewmodel',
        'eteration/ui/messages-cookies',
        'eteration/widgets/common/ui-force-password-renew',
        'eteration/eteration-i18n',
        'ui-helper/cookie-helper',
        'ui-helper/storage-helper',
        'bfp',
        'eteration/ui/faqsearch-viewmodel',
        'ui-helper/gtm-helper',
        'eteration/widgets/ui-session-controls',
        'common/recaptcha-constants',
        'ui-helper/accessibility-helper',
        'eteration/widgets/ui-cms',
        'jquery.accessibility',
        'eteration/widgets/ui-recaptcha',
        'eteration/widgets/ui-etrselect',
        'eteration/widgets/ui-dropdownselect',
        'eteration/widgets/ui-mschangepassword',
        'eteration/widgets/common/ui-login-otp',
        'eteration/widgets/ui-recaptcha-enterprise'
    ],
    function ($, ko, Eteration, etrAjax, BaseViewModel, Signup, userpref, loginView, messagesCookiesView, forcePassword, i18n, cookieHelper, storageHelper, bfp, SearchVM, gtmHelper, sessionControls, recaptchaConstants, AccessibilityHelper) {
        //captcha enterprise
        ko.bindingHandlers.captchaEnterprise.addRecaptchaToScript();

        window.useTccPortalLocale = false;

        var self = this;

        self.allowedEmailLogin = ko.observable();
        self.allowedTcIdLogin = ko.observable();
        self.allowedMobilePhoneLogin = ko.observable();
        self.loggedIn = ko.observable(false);
        self.msMainPageLink = ko.observable();
        self.headerHolidayStaticLink = ko.observable();
        self.headerTccStaticLink = ko.observable();
        self.headerMsStaticLink = ko.observable();
        self.headerFeedbackLink = ko.observable();
        self.headerSignUpLink = ko.observable();
        self.headerTccSignUpLink = ko.observable();
        self.headerMsPageLink = ko.observable();
        self.headerTccPageLink = ko.observable();
        self.passengerregistirationLinksForLogin = ko.observable(false);
        self.isMobile = $(window).width() < 992;
        self.isCorpUserRole = ko.observable(false);
        self.isCompanyUserRole = ko.observable(false);
        self.isMemberUserRole = ko.observable(false);
        self.isCurrencyFormVisible = ko.observable(true);
        self.isHolidayLinkActive = ko.observable(false);
        self.isWalletActive = ko.observable(false);
        self.showOtp = ko.observable();
        self.isUserRoleSetCompleted = ko.observable(false);

        window.isTouchable = 'ontouchstart' in document.documentElement || window.navigator.msPointerEnabled ? true : false;


        function loadLoginSettings(callback){
            var msloginsettings = $.jStorage.get("app.miles/miles/headerloginsettings");

            if (!msloginsettings) {
                etrAjax.get({
                    app: 'app.ms',
                    service: '/miles/headerloginsettings',
                    disableLoader: true,
                    disableErrorHandling: true,
                    callback: function (response) {
                        callback(response.data);
                        $.jStorage.set("app.miles/miles/headerloginsettings", response.data, {TTL: 3600000});
                    }
                });
            } else {
                callback(msloginsettings);
            }
        }
        self.wsMessageCode = ko.observable();

        self.openCookieOptions = function() {
            var errorContent = document.getElementById("errorContent");
            if(!errorContent) {
                $('body').append('<div id="errorContent"></div>');
            }
            i18n.loadMsgs(['common'], function() {
                Eteration.loadStaticFragment({
                    app: 'app.ibs',
                    module: 'messages',
                    disableLoader: true,
                    el: $('#errorContent'),
                    success: function () {
                        ko.applyBindings(new messagesCookiesView.ViewModel(), $("#errorContent")[0]);
                    }

                });
            });
        };

        //show cookie view on start
        self.openCookieOptions();

        function isMilesAndSmilesPageRegex() {
            var pattern = /\/miles-and-smiles\//i;
            return pattern.test(window.location.pathname);
        }

        self.openLogin = function(isLoginFromHomepage) {
            var loginModule = isMilesAndSmilesPageRegex() ? 'mstcclogin' : 'login';
            var from = isLoginFromHomepage ? "fromHomepage" : "notFromHomepage";

            Eteration.loadStaticFragment({
                app : 'app.ms',
                module : loginModule,
                disableLoader: true,
                el : $('#siginModalContainer'),
                success : function() {
                    $('#signinModal').modal("show");
                    $('#signinModal').attr({"data-fromhome" : from});
                    ko.applyBindings(new loginView.ViewModel(function() {
                        window.location.reload();
                    }), $("#siginModalContainer")[0]);
                }

            });
        };

        self.setHeaderLinks = function() {
            var counter = 0;
            var checkUserRoleAndSetLinks = setInterval(function() {
                if(typeof(faqsearchLinks) !== 'undefined') {
                    self.headerHolidayStaticLink(faqsearchLinks.holidayStaticLink);
                    self.headerTccStaticLink(faqsearchLinks.corporateClubStaticLink);
                    self.headerMsStaticLink(faqsearchLinks.milesAndSmilesStaticLink);
                    self.msMainPageLink(faqsearchLinks.msMainPage);
                    self.headerFeedbackLink(faqsearchLinks.feedbackForm);
                    self.headerTccPageLink(faqsearchLinks.tccMainPage);
                    self.headerSignUpLink(faqsearchLinks.msSignUp);
                    self.headerTccSignUpLink(faqsearchLinks.tccPortalRegistrationPage);

                    var roleCheck = (self.isMemberUserRole() || self.isCompanyUserRole() || self.isCorpUserRole());
                    if(roleCheck) {
                        if (self.isMemberUserRole() || self.isCompanyUserRole()) {
                            self.headerMsPageLink(faqsearchLinks);
                        } else {
                            self.headerMsPageLink(faqsearchLinks.msMainPage);
                        }
                        self.isUserRoleSetCompleted(true);
                        clearInterval(checkUserRoleAndSetLinks);
                    }
                }

                if(counter > 5) clearInterval(checkUserRoleAndSetLinks);
                else counter++;
            }, 1000);
        }
        
        function headerRightPaneWrapper() {
        	var elm = $('.main-header .quick-nav');
        	if(!elm.length){
        		elm = $('#headerRightPaneWrapper');
        	}
			var htmlTmpl ="";
			if($('body').hasClass('new-tk')){
				htmlTmpl = 'headerRightPaneContentNew';
				$('header').next().next().children('#minibooker').css({'padding-top': '100px'});
			}else{
				htmlTmpl = 'headerRightPaneContent';
			}
			if (!elm.length)
			return;

            if(!$('header:not(.booking-header)').hasClass('has-top-bar')){
                $('header:not(.booking-header)').addClass('has-top-bar');
            }

			if (elm[0]) {
				Eteration.loadStaticFragment({
					app: 'app.ms',
					module: 'header',
                    tmpl: htmlTmpl,
                    cache: true,
                    el: elm,
                    success: function () {
                        i18n.loadMsgs(['ms','common'], function () {
                            ko.applyBindings(new userpref.UserPreferencesVM(), elm[0]);
                            var lsCallbackFunction=function(response){
                                var loginPreferences = response ? response.loginPreferences : {};

                                self.allowedEmailLogin(loginPreferences.allowLoginWithEmail || false);
                                self.allowedMobilePhoneLogin(loginPreferences.allowLoginWithMobilePhone || false);
                                self.allowedTcIdLogin(loginPreferences.allowLoginWithTCId || false);
                            };
                            
                            if (sessionControls.activePageNumber != 'undefined' && sessionControls.activePageNumber != 0 && sessionControls.activePageNumber != 1) {
                    			self.isCurrencyFormVisible(false);
                            }

                            $(document).ready(function () {
                                checkSession();
                                AccessibilityHelper.fixUserMenuDropdown();
                                $('#signin,#headerSigninModal').on('click',function(){
                                    handleSigninClick(lsCallbackFunction);
                                });
                            });
                        },"ko_app");
                    }
                });
            }

        }

        $(document).ready(function () {
            var count = 0;
            var passengerRegistirationLinksInterval = setInterval(function() {
                count++;
                if (window.passengerregistirationLinks) {
                    self.passengerregistirationLinksForLogin(true);
                    clearInterval(passengerRegistirationLinksInterval);
                }
                if(count > 5)
                    clearInterval(passengerRegistirationLinksInterval);
            }, 1000);
			
			//WEB-25997 for removing the Corporate Club Button
			setTimeout(function(){
				var url = window.location.href;
				var languageCountry = document.querySelector('meta[name="languagecountry"]').content;
                var elemHoliday = document.getElementById( 'holidayLink' );

                if(url.includes('pt-br')){
					$('#tccLink').remove();
				} else if(languageCountry == 'pt-br'){
					$('#tccLink').remove();
				}

                if (elemHoliday) {
                    if (self.isMobile) {
                        elemHoliday.remove();
                    } else {
                        if (languageCountry == "tr-tr" || languageCountry == "en-tr") {
                            elemHoliday.classList.remove("d-none");
                        } else {
                            elemHoliday.remove();
                        }
                    }
                }
			},400);
			
        });
        
        $(document).ready(function () {
        	if (localStorage.getItem('bfp') == null || !localStorage.getItem('bfp').length) {
	        	if(bfp != null){
		        	var prms = bfp.load({monitoring: false});

		        	if (prms != null) {
			        	prms.then(function (p) { return p && p.get(); }).then(function (res) { res && localStorage.setItem('bfp', res.visitorId); })["catch"](function (error) {});
		        	}
	        	}
        	}
        });

        self.loadAwardTicket = function() {
            var links = typeof scheduleLinks != 'undefined' ? scheduleLinks : faqsearchLinks;
            etrAjax.post({
                app : 'app.ibs',
                service : '/awardticketbooking/profile2',
                data : links,
                callback : function() { }
            });
        };

        $(document).on('click', '.mega-menu-main li a.thyHeaderLink', function(){

            var thyHeaderLinkVar = $(this);
            if(!thyHeaderLinkVar.hasClass('active')) {
                $( ".mega-menu-main li a.thyHeaderLink.active" ).each(function() {
                    $(this).removeClass('active');
                    $(this).next().collapse('hide');
                });
                thyHeaderLinkVar.addClass('active');
                thyHeaderLinkVar.next().collapse('show');
            } else {
                thyHeaderLinkVar.removeClass('active');
                $(this).next().collapse('hide');
            }
        });
        
        //for Footer Mega menu
        $(document).on('click', '.footer-btn',function() {
            if($(this).hasClass('collapsed')) {
                $('.footer-btn').each(function() {
                    $($(this).attr('data-bs-target')).addClass('hide');
                    $(this).children('i').removeClass('fa-sort-asc').addClass('fa-sort-desc');
                });
                $(this).addClass('collapsed');
                $($(this).attr('data-bs-target')).removeClass('hide');
                $(this).children('i').removeClass('fa-sort-desc').addClass('fa-sort-asc');
                var el=$(".footer-content");
                document.querySelector('html', 'body').scrollTo({
                    top: el.offset().top+el.height(),
                    left: 0,
                    behavior: 'smooth'
                })
            } else {
                $('.footer-btn').each(function() {
                    $($(this).attr('data-bs-target')).addClass('hide');
                    var el=$(".footer-content");
                    $(this).children('i').removeClass('fa-sort-desc').addClass('fa-sort-asc');
                    document.querySelector('html', 'body').scrollTo({
                        top: el.offset().top+el.height(),
                        left: 0,
                        behavior: 'smooth'
                    })
                });
            }
        });
        
        //for M&S Signup
        $(document).on('change', '#signup-countryCode,#signup-cityCode,#signup-townCode' , function() {
            var t = $(this);
            t.children().each(function() {
                if ($(this).is(':selected')) {
                    t.parent().removeClass("has-error").children('.has-error').removeClass("has-error");
                }
            });
        });

        self.typeAheadList = ko.observableArray();
        self.langCountryCode = $('meta[name=languagecountry]').attr("content");
        self.queryParam = ko.observable();

        $(document).on('keyup keydown keypress', "#searchBoxTextInput", function(event) {
            var queryKey = event.target.value;
            if (queryKey.length > 0) {
                etrAjax.post({
                    app: 'app.search',
                    service: '/faqsearch/searchresultfromtypeahead',
                    data: { parameter: queryKey, langCountryCode: self.langCountryCode },
                    disableLoader:true,
                    disableErrorHandling:true,
                    callback: function(response) {
                        self.typeAheadList(response.data);
                    }
                });
            }

            if (event.keyCode == 13) {
                storageHelper.setItem({
                    key: "FAQ_KEY",
                    value: $("#searchBoxTextInput").val(),
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                });
                window.location = faqsearchLinks.faqHome;
            }

            $("#searchBoxTextInput").autocomplete({
                source: self.typeAheadList(),
                appendTo: ".form.search-form",
                select: function(event, ui) {
                    self.queryParam(ui.item.value);
                    $("#searchBoxTextInput").val(self.queryParam());
                    storageHelper.setItem({
                        key: "FAQ_KEY",
                        value: $("#searchBoxTextInput").val(),
                        webStorageType: storageHelper.Stores.SESSION_STORAGE
                    });
                    window.location = faqsearchLinks.faqHome;
                }
            });
        });
        $(document).on('click', "#help-search", function() {
            storageHelper.setItem({
                key: "FAQ_KEY",
                value: $("#searchBoxTextInput").val(),
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });
            window.location = faqsearchLinks.faqHome;
        });

        $(document).ready(function() {
            if($('#headerRightPaneWrapper').length || $('.main-header .quick-nav').length) {
            	headerRightPaneWrapper();
            }
        });

        //OTP
        var loginOperation = 'HOME';
        self.otpRequiredObject = ko.observable();
        self.showOtp = ko.observable(false);
        self.loginObject = ko.observable();
        self.otpCallBackParams = ko.observable();
        self.otpResult = ko.observable();
        self.showLoader = ko.observable(false);
        var otpCallBackStatus = false;

        self.otpCallBack = function (params){
            if(params != "RESET"){
                params ? otpCallBackStatus = true : otpCallBackStatus = false ;
                $("#signin").trigger("click");
                self.otpCallBackParams(params);
                self.handleSignInWithOtp();
            }else{
                otpCallBackStatus = false
            }
        }

        self.handleSignInWithOtp = function (){
            ko.bindingHandlers.captchaEnterprise.validateCaptcha("msloginotp").then(function (token) {
                var recaptchaInfo = JSON.parse(JSON.stringify({response: token}));
                function getOtpCallBackParams() {
                    var otpCallBackParamsObj = self.otpCallBackParams();
                    if (otpCallBackParamsObj) {
                        otpCallBackParamsObj.recaptchaInfo = recaptchaInfo || {};
                    }
                    return otpCallBackParamsObj || {};
                }
                setTimeout(function () {
                    self.showLoader(true);
                }, 1);

                var loginPost = {
                    app: 'app.ms',
                    service: '/login/signin',
                    disableLoader: true,
                    disableErrorHandling: true,
                    disableLoaderTimeout: true,
                    data: getOtpCallBackParams(),
                    setTokenX: true,
                    callback: function (response) {
                        setTimeout(function () {
                            self.showLoader(false);
                        }, 100);
                        if (response.type === "SUCCESS" && response.data && !response.data.otpRequired && !response.data.forceChangePinNumber) {
                            gtmHelper.pushMSLogin(response.data, {page: '', category: ''}, self.loginObject().loginType)
                            if(response.data && response.data.userLanguage != null && response.data.userCountry != null){
                                var userLanguage = response.data.userLanguage;
                                var userCountry = response.data.userCountry;

                                new userpref.UserPreferencesVM().changePreferences(userLanguage.toLowerCase(), userCountry.toLowerCase(), true);
                            }

                            $('#triggerForLoginLogout').trigger('click');

                            storageHelper.setItem({
                                key: "profileIdKey",
                                value: response.data.profileIdKey,
                                webStorageType: storageHelper.Stores.SESSION_STORAGE
                            });

                            var query = window.location.hash;
                            if (query && query.indexOf('#login?url=') > -1) {
                                var link = window.location.hash.split("#login?url=")[1];
                                window.location.hash = "";
                                if(link && link.match(/^https:\/\/.*\.turkishairlines.com/)){
                                    window.location = link;
                                }
                                else{
                                    window.location.reload();
                                }
                                return false;
                            } else if (response.data.role === "COMPANY") {
                                window.location.href = window.faqsearchLinks.milesAndSmilesMembershipList;
                            } else {
                                if(window.willReloadAfterLogin) {
                                    if(response.data && response.data.displayName) {
                                        $('#triggerForLoginLogout').trigger('click');
                                        checkSession();
                                    }
                                } else {
                                    window.location.reload();
                                }
                            }

                        }
                        else {

                            if ("error" in response) {
                                var messages = response.error.validationMessages;

                                if (messages && messages.length) {

                                    var code = messages[0].code;
                                    var msg = messages[0].msg;

                                    // pending member
                                    if (code === "MS00201205" || msg === "Error-MS-MS00201205") {
                                        self.webServiceMessageCode(code);
                                    }

                                    if (code === "MS00201212" || msg === "Error-MS-MS00201212" || code === "MS00201211" || msg === "Error-MS-MS00201211") {
                                        self.webServiceMessageCode("Error-MS-MS00201205");
                                    }

                                    //OTP error
                                    if (code === 'MS009999OTP_INV' || msg === "Error-MS-MS009999OTP_INV") {
                                        self.otpResult(response);
                                    }
                                    otpCallBackStatus = false;
                                }
                            } else {
                                if (response.data.forceChangePinNumber) {
                                    self.showOtp(false);
                                    otpCallBackStatus = false;
                                    var loginData = getOtpCallBackParams();
                                    forceChangePinModal(loginData);
                                }else{
                                    checkOtpStatus(getOtpCallBackParams());
                                }
                            }
                        }
                    }
                }

                etrAjax.post(loginPost);
            });
        }

        function checkOtpStatus (loginData) {
            ko.bindingHandlers.captchaEnterprise.validateCaptcha("msloginotp").then(function (token) {
                if (!$("#otpContainer").length > 0) {
                    initOtp();
                }
                var data = {
                    "type": "msloginotp",
                    "recaptchaInfo": JSON.parse(JSON.stringify({response: token}))
                }
                self.otpRequiredObject({
                    "data": data,
                    "module": "ms",
                    "types": "msloginotp",
                    "callback": self.otpCallBack,
                    "captchaData": JSON.parse(JSON.stringify({response: token}))
                });

                self.loginObject(loginData);

                self.showOtp(false);
                self.showOtp(true);
                return;
            });

        }

        function initOtp() {
            $('body').append('<div id="otpContainer"></div>');
            Eteration.loadStaticFragment({
                app : 'app.ms',
                module : 'login',
                tmpl: 'headerOtp',
                disableLoader: true,
                el : $("#otpContainer"),
                success : function() {
                    ko.applyBindings( self, $("#otpContainer")[0]);
                    $("#signin").trigger("click"); // signin modal Closed
                }
            })
        }

        function handleSigninClick(lsCallback){
            loadLoginSettings(lsCallback);
            headerSingupForm();
        }
        
        function loadingModal() {
            var query = window.location.hash;
            if (query.indexOf('#login?url=') > -1 && !self.loggedIn()) {
                var loginElement = $('#loginModalCont');
                if (!loginElement.length) {
                    loginElement = $('<div id="loginModalCont"><div id="loginModalEl"></div></div>').appendTo('body');
                }

                Eteration.loadStaticFragment({
                    app: 'app.ms',
                    module: 'login',
                    tmpl: 'login',
                    el: $("#loginModalEl"),
                    success: function () {
                        ko.applyBindings(new loginView.ViewModel(loginCallback), $("#loginModalCont")[0]);
                        setTimeout(function () {
                            loginElement.find('#signinModal').modal('show');
                        }, 1000);
                    }
                });
            }
        }

        function loginCallback() {
            var link = window.location.hash.split("#login?url=")[1];

            if(link&&link.match(/^https:\/\/.*\.turkishairlines.com/)){
                window.location.hash = "";
                window.location = link;
            }

        }


        function forceChangePinModal(params) {

            $('body').append('<div id="forcepasswordContainer"></div>');
            Eteration.loadStaticFragment({
                app : 'app.ms',
                module : 'forcepassword',
                disableLoader: true,
                el : $("#forcepasswordContainer"),
                success : function() {
                    ko.applyBindings( new forcePassword.ViewModel(params), $("#forcepasswordContainer")[0]);
                    $("#signin").trigger("click"); // signin modal Closed

                    $("#forcePasswordRenewModal").modal("show"); // Forcepin Modal Activated

                }
            });
        }

        var checkWalletActive = function(){
            etrAjax.get({
                app: 'app.ms',
                service: '/tkwallet/param/active',
                callback: function (response) {
                    self.isWalletActive(response.data?response.data:false)
                }
            });
        }
        var isLoggedIn = function(loggedIn, name) {
            self.loggedIn(loggedIn);
            if(loggedIn) {

                $('#headerRightPaneWrapper').removeClass('logouted').addClass('loginned');
                $('.navbar-nav.loginned .userfullname').html(name);
                checkWalletActive();
            } else {
                $('#headerRightPaneWrapper').removeClass('loginned').addClass('logouted');
                $('.navbar-nav.loginned .userfullname').html('');
            }
        };

        var sendGtmEvents= function(extraInfo){
            var sendEvents = function(extraInfo,clientInfo){
                gtmHelper.pushLoginData(extraInfo,clientInfo);
            };
            var sessionCache  = function(){
                return {
                    set : function(k,v){
                        try{
                            storageHelper.setItem({
                                key: k,
                                value: JSON.stringify(v),
                                webStorageType: storageHelper.Stores.SESSION_STORAGE
                            });
                        }
                        catch(e){
                            console.error(e);
                        }
                    },
                    get: function(k){
                        try{
                            var item = storageHelper.getItem({ key: k, webStorageType: storageHelper.Stores.SESSION_STORAGE });
                            if(item){
                                return JSON.parse(item);
                            }
                        }
                        catch(e){
                            console.error(e);
                        }
                        return null;
                    }
                }
            };
            var cache = sessionCache();
            var clientInfo =cache.get("x-clientInfo");
            if(clientInfo){
                sendEvents(extraInfo,clientInfo);
                return;
            }

            etrAjax.get({
                app:'app.common',
                service:'/parameters/clientinfo',
                disableLoader : true,
                disableErrorHandling: true,
                callback : function(response){
                    if(response&&response.data){
                        cache.set("x-clientInfo",response.data);
                        sendEvents(extraInfo,response.data);
                    }
                    else{
                        sendEvents(extraInfo);
                    }
                }
            });
        };

        function checkSession() {
            etrAjax.get({
                app: 'app.ms',
                service: '/login',
                disableLoader: true,
                callback: function (response) {
                    if(!response.data)
                        return;

                    window.isCorpUser = (response.data.role == "CORPORATE");
                    window.isCompanyUser = (response.data.role == "COMPANY");
                    window.isMemberUser = (response.data.role == "PUBLICMEMBER") || (response.data.role == "MEMBER");

                    self.isCorpUserRole(window.isCorpUser);
                    self.isCompanyUserRole(window.isCompanyUser);
                    self.isMemberUserRole(window.isMemberUser);

                    self.setHeaderLinks();

                    $(document).trigger('isCorpUserRoleSeted',window.isCorpUser);

                    //Corporate user main page is "https://sit.turkishairlines.com/en-us/tccschedule" header logo link coming from sdl this if block WEB-15343 fixed 
                    if(window.isCorpUser){
                        var languageCountry = document.querySelector('meta[name="languagecountry"]').content;
                        var megaMenuFirstLink = $('.mega-menu-main > li:nth-child(1) .mega-menu-items a').first();
                        var megaMenuMBLFirstLink = $('.mega-menu-mbl > li:nth-child(2) .sub-menu-item').first();
                        
                        var tccScheduleLink = window.origin+'/'+languageCountry+'/tccschedule/';
                        var wrongKeys = ["rezervasyon",
                                        "booking"];
                        var urlKeys = megaMenuFirstLink.attr('href').split("/");
                        var urlKey = urlKeys[urlKeys.length-1] != ""  ? urlKeys[urlKeys.length-1] : urlKeys[urlKeys.length-2];
                                        


                    }
                    
                    loadingModal();
                    var userName = '';
                    if (response.data.displayName && response.data.displayName !== null) {
                        userName = response.data.displayName;
                    } else if (response.data.username !== null) {
                        var strPos = response.data.username.indexOf(",");
                        userName = response.data.username.substring(4, strPos);
                    } else if (!response.data.displayName && response.data.loggedIn) {
                        etrAjax.get({
                            app: 'app.ms',
                            service: '/miles/memberprofile',
                            callback: function (response) {
                                if(response.data) {
                                    userName = response.data.personalInfo.firstName + " " + response.data.personalInfo.surname;
                                }
                            }
                        });
                    }
                    isLoggedIn(response.data.loggedIn, userName);
                    sendGtmEvents(response.data);
                },
                disableErrorHandling: true,
                preError: function() {
                    isLoggedIn(false, '');
                }
            });
        }

        function headerSingupForm() {
            if (!$('ul#signupForm').length)
                return;
            Eteration.loadStaticFragment({
                app: 'app.ms',
                module: 'login',
                tmpl: 'headerLogin',
                cache: true,
                el: $('ul#signupForm'),
                success: function () {
                    bindSingupForm();
                }
            });
            
            if($('ul#signupForm')){
            	if($('.mega-menu-main li a.thyHeaderLink').hasClass('active')){
                    $( ".mega-menu-main li a.thyHeaderLink.active" ).each(function() {
                         $(this).removeClass('active');
                         $(this).next().collapse('hide');
                     });
                }
            }

            function bindSingupForm() {
                var signinBTN = $('#signinBTN');
                if (signinBTN.length > 0) {
                    var signinEvents = signinBTN.data("events");
                    if (!signinEvents) {

                        var QuickLoginVM = function () {

                            ko.utils.extend(this, new BaseViewModel.FormViewModel());

                            function RecaptchaInfo() {
                                var self = this;
                                self.privateKey = ko.observable();
                                self.remoteIp = ko.observable();
                                self.challenge = ko.observable();
                                self.response = ko.observable();
                            }

                            var self = this;
                            self.username = ko.observable();
                            self.password = ko.observable();
                            self.loginType = ko.observable("1");

                            self.regionCodes = ko.observableArray();
                            self.mobilePhoneNumber = ko.observable();
                            self.mobilePhoneCountryCode = ko.observable();
                            self.tckn = ko.observable();
                            self.email = ko.observable();
                            self.emailtcc = ko.observable();
                            self.recaptchaInfo = ko.observable(new RecaptchaInfo());
                            self.isCaptchaRequired = ko.observable(false);
                            self.isCaptchaRequiredForSecurityQuestion = ko.observable(false);
                            self.webServiceMessageCode = ko.observable();

                            self.showWebServiceErrorMessage = ko.observable(false);

                            $('#username' + self.loginType()).alphanum();

                            self.rememberSelection = ko.observable();
                            self.rememberSelection(cookieHelper.getCookie("mslogin_rememberSelection") ? true : false);

                            if (self.rememberSelection()) {
                                if (cookieHelper.getCookie("mslogin_username1")) {
                                    self.username(cookieHelper.getCookie("mslogin_username1"));
                                }else{
                                    self.username('');
                                }
                                if (cookieHelper.getCookie("mslogin_username2")) {
                                    self.email(cookieHelper.getCookie("mslogin_username2"));
                                }else{
                                    self.email('');
                                }
                                if (cookieHelper.getCookie("mslogin_username3_country_code")) {
                                    self.mobilePhoneCountryCode(cookieHelper.getCookie("mslogin_username3_country_code"));
                                    self.mobilePhoneNumber(cookieHelper.getCookie("mslogin_username3"));
                                }else{
                                    self.mobilePhoneNumber('');
                                }
                                if (cookieHelper.getCookie("mslogin_username4")) {
                                    self.tckn(cookieHelper.getCookie("mslogin_username4"));
                                }else{
                                    self.tckn('');
                                }
                            }

                            self.deleteOtherLoginTypeCookies = function (ignoredLoginType) {
                                for (var int = 1; int < 5; int++) {
                                    if (ignoredLoginType != int) {
                                        document.cookie = "mslogin_username" + [int] + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                        if ("mslogin_username3" === "mslogin_username" + [int]) {
                                            document.cookie = "mslogin_username3_country_code" + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                        }
                                    }
                                }
                            };

                            self.signinCorp = function () {
                            	var validationResult = self.validationContext.Validate();
                            	if (validationResult.valid) {
                            		$('.signin-container .partial-loader').addClass('loading');

                            		var requestForSignin = {
                            			app: 'app.cc',
                            			service:'/corporateclub/signin',
                            			data: {
                            				'username': self.emailtcc(),
                            				'loginType': 'tcc',
                            				'password': self.password()
                            			},
                            			disableLoader: true,
                                        setTokenX: true,
                            			callback:function(response) {
                            				$('.signin-container .partial-loader').removeClass('loading');
                            				if(response.type=="SUCCESS"){
                            					window.location.reload();
                            				} else {
                            					$('#errorpasswordMsg').html('<small><i class="fa fa-warning red"></i>'+i18n.get('TextField-CAMS-64')+'</small>');
                            				}
                            			},
                            			preError: function() {
                            				window.location.reload();
                            			}
                            		};
                            		etrAjax.post(requestForSignin);
                            	}
                            }

                            self.validationContextForPasswordActivateLightbox = ko.jqValidation({postValidators:[]});
                            function LoginFields() {

                                var self = this;
                                self.flyerId = ko.observable(); //"TK002203593"
                                self.password = ko.observable(); //pin number
                                self.loginType =  ko.observable("1");
                                self.emailtcc = ko.observable();

                            }
                            self.loginFields = ko.observable(new LoginFields());
                            self.tkNumberVisible = ko.observable(false);
                            self.forgotPasswordMode = ko.observable();
                            
                            self.corporateLoginActive = ko.observable(false);
                            if(!window.corporateLoginRequested) {
	                    		var corporateLoginActive = {
	                    			app: 'app.cc',
	                                service:'/corporateclub/corporateLoginActive',
									disableLoader: true,
	                                callback:function(response) {
	                                	self.corporateLoginActive(response.data);
	                                	window.corporateLoginActive = response.data;
	                                	window.corporateLoginRequested = true;
	                                }
	                            };
	                    		etrAjax.get(corporateLoginActive);
                    		} else {
                	        	self.corporateLoginActive(window.corporateLoginActive);
                	        }
                    		
                            self.openForgotPasswordModal = function(data, e){
                                var corpLoginElement = $('#corpLogin');
                                var pwdActivateLightBoxElement = $('#ob-passwordActivateLightbox');
                                var signinModal = $("#signinModal");

                                if(!corpLoginElement.length || !corpLoginElement.hasClass('active')) {
                                    window.location.href = faqsearchLinks.forgotpassword;
                                } else {
                                    self.forgotPasswordMode(true);
                                    if(!pwdActivateLightBoxElement.is(':visible')){
                                        pwdActivateLightBoxElement.appendTo('body').modal("show");
                                    }
                                    signinModal.appendTo('body').modal("hide");
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }

                            self.passwordActivateSuccessModal = function(){
                                $("#passwordActivateSuccessModal").appendTo('body').modal("show");
                                self.hidePasswordActivateLightbox();
                            }
                            self.passwordActivateNotFoundModal = function(){
                                $("#passwordActivateNotFoundModal").appendTo('body').modal("show");
                                self.hidePasswordActivateLightbox();

                            }
                            self.hidePasswordActivateLightbox = function(){
                                $("#ob-passwordActivateLightbox").appendTo('body').modal("hide");
                                $("#ob-passwordActivateLightbox").modal("hide");
                            }
                            $("#ob-passwordActivateLightbox").on('hide.bs.modal', function() {});

                            self.passwordActivateResetPin = function(){
                                self.showWebServiceErrorMessage(false);
                                var validationResult = self.validationContextForPasswordActivateLightbox.Validate();
                                if (validationResult.valid) {
                                    if(typeof grecaptcha !== 'undefined' && self.isCaptchaRequired()) {
                                        self.recaptchaInfo().response(grecaptcha.getResponse());
                                        grecaptcha.reset();
                                    }

                                    var uiMap = {
                                        'captchaDivId': 'captchaDivId',
                                        'email': 'email'
                                    };

                                    var forgotPasswordDataBlock = {
                                            username: self.email(),
                                            recaptchaInfo: JSON.parse(ko.toJSON(self.recaptchaInfo()))
                                    };

                                    var requestForForgottenPassword = {
                                        app: 'app.cc',
                                        service:'/corporateclub/forgottenpassword',
                                        uiMap: uiMap,
                                        data: forgotPasswordDataBlock,
                                        disableLoader:false,
                                        callback:function(response) {
                                            if(response.data){
                                                self.passwordActivateSuccessModal();
                                            } else {
                                                etrAjax.showInfoModal('', ['TextField-CAMS-118']);
                                            }
                                            $('#ob-passwordActivateLightbox').modal('hide');
                                        }
                                    };
                                    etrAjax.post(requestForForgottenPassword);
                                }
                            }

                            recaptchaConstants.addRecaptchaV2();

                            self.openChangePasswordModal = function(){
                                $("#signinModal").appendTo('body').modal("hide");
                                $("#changePasswordModal").appendTo('body').modal("hide");
                                $("#changePasswordModal").appendTo('body').modal("show");
                            }
                            self.signin = function () {
                                $('#captchaerror').remove();
                                var validationResult = self.validationContextForSigninForm.Validate();
                                if (validationResult.valid) {
                                    $('.signin-container .partial-loader').addClass('loading');

                                    self.allowPageChangeWithoutClearTerminal();

                                    var usernameVal;

                                    if (self.loginType() === '3') {
                                        usernameVal = self.mobilePhoneCountryCode() + $('#username3').val();
                                    } else {
                                        usernameVal = $('#username' + self.loginType()).val();
                                    }

                                    if(typeof grecaptcha !== 'undefined' && self.isCaptchaRequired()) {
                                        self.recaptchaInfo().response(grecaptcha.getResponse());
                                        grecaptcha.reset();
                                    }
                                    ko.bindingHandlers.captchaEnterprise.validateCaptcha("msloginotp").then(function (token) {

                                    var data =  {
                                            'username': usernameVal,
                                            'password': self.password(),
                                            'loginType': self.loginType(),
                                            'isReqWithRecaptchaEnterprise': true,
                                            'recaptchaInfo': JSON.parse(JSON.stringify({response: token})),
                                            'loginOperation': loginOperation
                                    }

                                    etrAjax.post({
                                        app: 'app.ms',
                                        service: '/login/signin',
                                        disableLoader: true,
                                        disableErrorHandling: true,
                                        disableLoaderTimeout: true,
                                        data: data,
                                        setTokenX: true,
                                        callback: function (response) {

                                            $('#errorusername' + self.loginType()).html('');
                                            $('#errormobilePhoneNumber').html('');
                                            $('#errorpassword').html('');
                                            $('.signin-container .partial-loader').removeClass('loading');

                                            if (response.type === "SUCCESS" && response.data && !response.data.forceChangePinNumber && !response.data.otpRequired) {
                                                gtmHelper.pushMSLogin(response.data, {page: "", category: "Header Menu"}, self.loginType());
                                            	if(response.data && response.data.userLanguage != null && response.data.userCountry != null){
                                                    var userLanguage = response.data.userLanguage;
                                                    var userCountry = response.data.userCountry;

                                                    new userpref.UserPreferencesVM().changePreferences(userLanguage.toLowerCase(), userCountry.toLowerCase(), true);
                                            	}

                                            	$('#triggerForLoginLogout').trigger('click');
                                                if (self.rememberSelection()) {
                                                    cookieHelper.setCookie("mslogin_rememberSelection", self.rememberSelection(), 365, "/", true);

                                                    if (self.loginType() === '3') {
                                                        cookieHelper.setCookie("mslogin_username3_country_code", self.mobilePhoneCountryCode(), 365, "/", true);
                                                        cookieHelper.setCookie("mslogin_username3", $('#username3').val(), 365, "/", true);
                                                    } else {
                                                        cookieHelper.setCookie("mslogin_username" + self.loginType(), $('#username' + self.loginType()).val(), 365, "/", true);
                                                    }
                                                    self.deleteOtherLoginTypeCookies(self.loginType());
                                                } else {
                                                    document.cookie = 'mslogin_rememberSelection=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                                    self.deleteOtherLoginTypeCookies();
                                                }

                                                storageHelper.setItem({
                                                    key: "profileIdKey",
                                                    value: response.data.profileIdKey,
                                                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                                                });

                                                var query = window.location.hash;
                                                if (query && query.indexOf('#login?url=') > -1) {
                                                    var link = window.location.hash.split("#login?url=")[1];
                                                    window.location.hash = "";
                                                    if(link && link.match(/^https:\/\/.*\.turkishairlines.com/)){
                                                        window.location = link;
                                                    }
                                                    else{
                                                        window.location.reload();
                                                    }

                                                    return false;
                                                } else if (response.data.role === "COMPANY") {
                                                    window.location.href = window.faqsearchLinks.milesAndSmilesMembershipList;
                                                } else {
                                                    if(window.willReloadAfterLogin) {
                                                        if(response.data && response.data.displayName) {
                                                            $('#triggerForLoginLogout').trigger('click');
                                                            checkSession();
                                                        }
                                                    } else {
                                                        window.location.reload();
                                                    }
                                                }
                                                self.isCaptchaRequiredForSecurityQuestion(false);
                                                self.isCaptchaRequired(false);

                                            }
                                            else {

                                                if ("error" in response) {
                                                    var messages = response.error.validationMessages;

                                                    if (messages && messages.length) {
                                                        var code;
                                                        var msg;
                                                        for (var i = 0; i < messages.length; i++) {
                                                            msg = messages[i].msg;
                                                            code = messages[i].code;
                                                            if (code == "MS00201205" || code == "MS00201210" || code == "MS00201211" || code == "MS00201212") {
                                                                $('#error-messageHeader').html('<small><i class="fa fa-warning red"></i><span>' + i18n.get(msg) + '</span>&nbsp<span id="clickHereBtn" class="text-decoration-underline cursor-pointer">' + i18n.get("Error-MS-MS000FP") + '</span></small>');
                                                                $("#clickHereBtn").click(function (e) {
                                                                    self.forgotPasswordMode(false);
                                                                    if (!$('#ob-passwordActivateLightbox').is(':visible')) {
                                                                        $("#ob-passwordActivateLightbox").appendTo('body').modal("show");
                                                                    }
                                                                    $("#signinModal").appendTo('body').modal("hide");
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                });
                                                            } else {
                                                                $('#error-messageHeader').html('<small><i class="fa fa-warning red"></i><span class="px-5 black">' + i18n.get(msg) + '</span></small>');
                                                            }
                                                        }

                                                        var code = messages[0].code;
                                                        msg = messages[0].msg;

                                                        //Error-CAMS-07
                                                        if (code === "Error-CAMS-07" || msg === "Error-CAMS-07") {
                                                            self.isCaptchaRequired(true);
                                                        }

                                                        // there is no security question for this user.
                                                        // so only will show information light box
                                                        if (code === "MS00201221" || msg === "Error-MS-MS00201221") {
                                                            self.webServiceMessageCode(code);
                                                            self.showForgotPasswordInfoModal();
                                                        }

                                                        // 3 times wrong login attempt
                                                        if (code === "MS00201225" || msg === "Error-MS-MS00201225") {
                                                            self.webServiceMessageCode(code);
                                                            self.isCaptchaRequiredForSecurityQuestion(true);
                                                            self.showSecurityQuestionModal();
                                                        }

                                                        // pending member
                                                        if (code === "MS00201205" || msg === "Error-MS-MS00201205") {
                                                            self.webServiceMessageCode(code);
                                                            self.isCaptchaRequired(true);
                                                        }

                                                        if (code === "MS00201212" || msg === "Error-MS-MS00201212" || code === "MS00201211" || msg === "Error-MS-MS00201211") {
                                                            self.webServiceMessageCode("Error-MS-MS00201205");
                                                            self.isCaptchaRequired(true);
                                                        }

                                                        //OTP error
                                                        if (code === 'MS009999OTP_INV' || msg === "Error-MS-MS009999OTP_INV") {
                                                            self.otpResult(response);
                                                        }

                                                        otpCallBackStatus = false;
                                                        self.defillInputByGivenId('#password');
                                                    }
                                                } else {
                                                    if (response.data.otpRequired) {
                                                        var loginData = {
                                                            'username': usernameVal,
                                                            'loginType': self.loginType(),
                                                            'password': self.password(),
                                                            'isReqWithRecaptchaEnterprise': true

                                                        }
                                                        checkOtpStatus(loginData);
                                                    } else if (response.data.forceChangePinNumber) {
                                                        var loginData = {
                                                            'username': usernameVal,
                                                            'loginType': self.loginType(),
                                                            'isReqWithRecaptchaEnterprise': true,
                                                            'recaptchaInfo': JSON.parse(ko.toJSON(self.recaptchaInfo()))
                                                        }
                                                        forceChangePinModal(loginData);
                                                    }
                                                }
                                            }
                                            },
                                            preError: function() {
                                                console.log("Reload 5");
                                                window.location.reload();
                                            }
                                        });
                                    });
                                }
                            }

                            self.forgotPasswordHeader = function () {
                                self.showWebServiceErrorMessage(false);
                                var validationResult = self.validationContextForForgotPassword.Validate();
                                if (validationResult.valid) {
                                    etrAjax.post({
                                        app: 'app.ms',
                                        service: '/miles/resetpinwithemail',
                                        captchaCheck: true,
                                        disableErrorHandling: false,
//											largeLoader : true,
//											loaderName : 'select_flights',
                                        data: {
                                            'ffid': $('#ob-forgotPasswordFfid').val(),
                                            'email': self.email()
                                        },
                                        callback: function (response) {

                                        	if(!response.data) {
                								return;
                							}

                                            self.webServiceMessageCode(response.data.code);
                                            if (response.data.code !== "MS00301400") {
                                                self.showWebServiceErrorMessage(true);
                                            } else {
                                                self.defillInputByGivenId('#ob-forgotPasswordFfid');
                                                self.defillInputByGivenId('#ob-forgotPasswordEmail');

                                                $("#ob-forgotPasswordModal").modal("hide");
                                                if (!$('#ob-forgotPasswordInfoModal').is(':visible')) {
                                                    $("#ob-forgotPasswordInfoModal").appendTo('body').modal("show");
                                                }
                                            }
                                        }
                                    });
                                }
                            };

                            self.doResetPin = function () {
                                var msg = i18n.get("Error-CAMS-07");
                                var error = "<div class=\"col-xs-12 nopadding mt-10\" id=\"captchaerror\"><small><i class=\"fa fa-warning red\"></i>&nbsp;" + msg + "</small></div>";
                                var validationResult = self.validationContextForQuestionAnswer.Validate();
                                $('#signinCaptcha').next('#captchaerror').remove();
                                var elemCaptcha = $(event.target).parents('.modal').find('#signinCaptcha');
                                if(typeof grecaptcha !== 'undefined' && self.isCaptchaRequiredForSecurityQuestion()) {
                                    var response = grecaptcha.getResponse() || elemCaptcha.find('.g-recaptcha-response').val();
                                    self.recaptchaInfo().response(response);
                                    grecaptcha.reset();
                                }
                                if (validationResult.valid) {
                                    if (self.isCaptchaRequiredForSecurityQuestion() && (self.recaptchaInfo().response() === undefined || self.recaptchaInfo().response() === null || self.recaptchaInfo().response() === "")) {
                                        if($('#signinCaptcha').length) {
                                            showErrorText(error, elemCaptcha);
                                        }
                                        self.recaptchaInfo().response("");
                                        return;
                                    } else {
//									Reset Pin request
                                        etrAjax.post({
                                            app: 'app.ms',
                                            service: '/miles/resetpinwithsecurityquestion',
                                            data: {
                                                'loginText': 'TK' + $('#header-securityQuestionAnswer-username').val(),
                                                'loginChannel': "1",
                                                'securityAnswer': $('#header-securityQuestionAnswer-input').val(),
                                                'fromLogin': true,
                                                'recaptchaInfo': JSON.parse(ko.toJSON(self.recaptchaInfo()))
                                            },
                                            callback: function (response) {
                                                if(response.data) {
                                                    self.webServiceMessageCode(response.data.code);
                                                    $("#securityQuestionAnswerModal").appendTo('body').modal("hide");
                                                    $("#ob-forgotPasswordInfoModal").appendTo('body').modal("show");
                                                    self.defillInputByGivenId('#header-securityQuestionAnswer-input');
                                                } else {
                                                    if(response.error) {
                                                        msg = i18n.get(response.error.validationMessages[0].msg);
                                                        error = "<div class=\"col-xs-12 nopadding mt-10\" id=\"captchaerror\"><small><i class=\"fa fa-warning red\"></i>&nbsp;" + msg + "</small></div>";
                                                        showErrorText(error, elemCaptcha);
                                                    }
                                                }
                                            },
                                            disableErrorHandling: true,
                                            preError: function() {
                                                showErrorText(error, elemCaptcha);
                                            }
                                        });
                                    }
                                } else {
                                    showErrorText(error, elemCaptcha);
                                }
                            };

                            var showErrorText = function(t, e) {
                                if(e.next('#captchaerror').length)
                                    e.next('#captchaerror').remove();
                                e.after(t);
                            };

                            self.captchaRequiredControl = function () {
                                $.ajax({
                                    url: "/com.thy.web.online.miles/ms/login/iscaptcharequired",
                                    type: "GET",
                                    contentType: "application/json; charset=utf-8",
                                    dataType: "json",
                                    data: {"loginType": self.loginType()},
                                    cache: false,
                                    success: function (response) {
                                        self.isCaptchaRequired(response.data);
                                    }
                                });
                            };

                            self.checkWithOutSigninChoice = function () {
                                $('#withoutLogin').prop('checked', true);
                            };

                            self.defillUsernameAndPasswordInputs = function () {
                                $('#username' + self.loginType()).val("");
                                $('#password').val("");
                            };

                            self.defillInputByGivenId = function (elementId) {
                                $(elementId).val("");
                            };

                            self.showSecurityQuestionModal = function () {
                                self.username("");
                                self.defillInputByGivenId('#header-securityQuestionAnswer-username');
                                $("#securityQuestionAnswerModal").appendTo('body').modal("show");
                                $("#signinModal").appendTo('body').modal("hide");
                            };

                            self.showForgotPasswordInfoModal = function () {
                                self.username("");
                                self.defillInputByGivenId('#ob-forgotPasswordFfid');
                                $("#ob-forgotPasswordInfoModal").appendTo('body').modal("show");
                                $("#signinModal").appendTo('body').modal("hide");
                            };

                            var lsCallback2=function(response){
                                $("#password").attr("maxlength", response.passwordLength);
                                $("#header-securityQuestionAnswer-input").attr("maxlength", response.securityQuestionAnswerMaxLenght);
                            };

                            loadLoginSettings(lsCallback2);


                            var regioncodes = $.jStorage.get("app.miles/parameters/regioncodes");
                            if (!regioncodes) {

                                var regionCodesQuery = {
                                    app: 'app.ms',
                                    service: '/parameters/regioncodes',
                                    disableLoader: true,
                                    disableErrorHandling: true,
                                    callback: function (response) {
                                        self.regionCodes.removeAll();
                                        self.regionCodes(response.data);
                                        $.jStorage.set("app.miles/parameters/regioncodes", response.data, {TTL: 21600000});

                                    }
                                };
                                etrAjax.get(regionCodesQuery);
                            } else {
                                self.regionCodes.removeAll();
                                self.regionCodes(regioncodes);
                            }


//						self.triggerSigninButtonOnMobile = function(){
                            $("#headerSigninModal").click(function () {
                                $("schuldeMobileSigninButton").trigger("click");
                            });
//						}

                            self.validationContextForSigninForm = ko.jqValidation({postValidators: []});
                            self.validationContextForForgotPassword = ko.jqValidation({postValidators: []});
                            self.validationContextForQuestionAnswer = ko.jqValidation({postValidators: []});
                        };
                        ko.cleanNode($("#signupForm")[0]);
                        ko.applyBindings(new QuickLoginVM(), $("#signupForm")[0]);
                    }
                }
            }
        }
        /************************** isCrisisPageActive **************************/
        var isCrisisPageActive = false;
        etrAjax.get({
            app: 'app.cms',
            service: '/content/isCrisisPageHomePageLogoGrayscale',
            disableLoader: true,
            callback: function(response) {
                if (response && response.data) {
                    isCrisisPageActive = response.data;
                    storageHelper.setItem({
                        key: "IS_CRISIS_HOMEPAGE_LOGO",
                        value: isCrisisPageActive,
                        webStorageType: storageHelper.Stores.SESSION_STORAGE
                    });
                    var root = document.documentElement;
                    root.setAttribute('data-theme', 'crisis');
                }
            }
        });
        /************************** isCrisisPageActive **************************/

        function signUpFunctionsForMs(refresh) {
            var passenger = $("#signupBTN").data("passenger");

            Eteration.loadStaticFragment({
                app: 'app.ms',
                module: 'signup',
                el: $('#sigupModalContainer'),
                success: function () {

                    $('#signupModal').modal("show");

                    if (window.isPhoneOrTablet)
                        ko.applyBindings(new Signup.ViewModel(refresh, passenger), $("#signupModal")[0]);
                    else
                        ko.applyBindings(new Signup.ViewModel(refresh, passenger), $("#sigupModalContainer")[0]);
                }
            });
        }

        $(document).on('click', '.navbar-nav.loginned .loginned .header-signedinuser', function () {
            if($(this).next()) {
                if(!$(this).hasClass('opened')) {
                    $(this).addClass('opened')
                    if($('.mega-menu-main li a.thyHeaderLink').hasClass('active')){
                        $( ".mega-menu-main li a.thyHeaderLink.active" ).each(function() {
                             $(this).removeClass('active');
                             $(this).next().collapse('hide');
                         });
                    }
                } else {
                    $(this).removeClass('opened')
                }
            }
        });

        $(document).on('click', '.navbar-nav.loginned .loginned .header-user-menu a', function () {
            if($('#msMenu').length) {
            	$('#msMenu').find('.navbar-collapse-milesandsmiles .navbar-nav li').eq($(this).closest('li').index()).find('a').trigger('click');
            }
        });

        $(document).on('click', '#signupBTN, #MSSignUpModal', function (e, refresh) {
            signUpFunctionsForMs(refresh);
        });

        $(document).on('click', '#FaqSearchBtn, #FaqSeachBtn', function (e, refresh) {
            // FAQ search links params for localhost
            if(window.location.host == 'localhost:8080') {
                window.faqsearchLinks = {"callCenter":"/en-us/any-questions/get-in-touch/","faqHome":"/com.thy.web.online.portal/index_search_faqhome.jsp","feedbackForm":"/en-us/any-questions/customer-relations/"};
            }
            //
            if (typeof(window.faqsearchLinks) !== 'undefined') {
                Eteration.loadStaticFragment({
                    app: 'app.search',
                    module: 'faqsearch',
                    tmpl: 'faqsearch',
                    success: function () {
                        $("#searchBoxTextTyped").attr("placeholder", i18n.get("Label-Genel-518"));
                        $('#faqSearchContainer').html('');
                        $('#faqSearchContainer').html($('#faqsearch').html());
                        $('#faqsearch').html('');
                        ko.cleanNode($("#faqSearchContainer")[0]);
                        ko.applyBindings(new SearchVM.ViewModel(), $("#faqSearchContainer")[0]);
                    }
                });
            }
        });

        var checkHeaderUpdated = function(a, b) {
            if(!window.isPhone) {
                if(window.willReloadAfterLogin) {
                    $('#triggerForLoginLogout').trigger('click');
                    isLoggedIn(a, b);
                } else {
                    window.location.href = window.location.origin;
                }
            } else {
                window.location.reload();
            }
        };

        self.recaptchaCallback = function() {
            // This is an empty function but it's a must to keep recaptcha working.
        }

        $(document).on('click', '.signoutBTN, #signoutBTN, #signoutBTNMobile', function () {
        	if(window.isCompanyUser || window.isMemberUser) {
                $.ajax({
                    url: "/com.thy.web.online.miles/ms/login/signout",
                    type: "GET",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    cache: false,
                    success: function (response) {
                        storageHelper.removeItem({ key: "X-Token", webStorageType: storageHelper.Stores.LOCAL_STORAGE });
                        gtmHelper.pushMSLogout();
                        if (response.type === "SUCCESS") {
                            checkHeaderUpdated(false, '');
                            $.ajax({
                                url: "/com.thy.web.online.ibs/ibs/booking/signout",
                                type: "GET",
                                contentType: "application/json; charset=utf-8",
                                dataType: "json",
                                cache: false,
                                complete: function () {
                                    checkHeaderUpdated(false, '');
                                    $.ajax({
                                        url: "ibm_security_logout",
                                        type: "GET",
                                        cache: false,
                                        complete: function () {
                                            checkHeaderUpdated(false, '');
                                            var terminatedConversationIds = cookieHelper.getCookie("terminatedConversationIds");
                                            var oldTerminatedConversationIds = $.jStorage.get("app.miles/miles/terminatedConversationIds");

                                            if (oldTerminatedConversationIds != null)
                                                terminatedConversationIds = terminatedConversationIds + oldTerminatedConversationIds;
                                            $.jStorage.set("app.miles/miles/terminatedConversationIds", terminatedConversationIds, {
                                                TTL: 3600000
                                            });
                                            $.jStorage.set("app.miles/miles/logouted", "logout", {
                                                TTL: 3600000
                                            });
                                            $.ajax({
                                                url: "/com.thy.web.online.miles/ms/login/clearcookies",
                                                type: "GET",
                                                contentType: "application/json; charset=utf-8",
                                                dataType: "json",
                                                cache: false,
                                                complete: function () {
                                                    if(!window.isPhone)
                                                        checkHeaderUpdated(false, '');
                                                    else {
                                                        if(document.getElementById("mimPageLogOutSelector") && document.getElementById("mimPageLogOutSelector") != null) {
                                                            window.location.reload();
                                                        } else if (window.location.hostname != "localhost") {
                                                            window.location.href = window.location.origin;
                                                        } else {
                                                            window.location.reload();
                                                        }
                                                    }
                                                    storageHelper.removeItem({ key: "profileIdKey", webStorageType: storageHelper.Stores.SESSION_STORAGE });
                                                    cookieHelper.removeItem("FFID");
                                                }
                                            });
                                        },
                                        error: function () {
                                            if(window.isPhone)
                                                window.location.reload();
                                        }
                                    });
                                },
                                error: function () {
                                    console.log("Reload 5");
                                    window.location.reload();
                                }
                            });
                        } else {
                            var messages = response.error.validationMessages;
                            for (var i = 0; i < messages.length > i; i++) {
                                console.log(messages[i].msg);
                            }
                        }
                    }

                });
        	} else {
        		var requestForSignin = {
        			app: 'app.cc',
        			service:'/corporateclub/logout',
        			callback: function() {
                        storageHelper.removeItem({ key: "X-Token", webStorageType: storageHelper.Stores.LOCAL_STORAGE });
                        window.location.href = window.location.origin;
                    }
        		};
        		etrAjax.get(requestForSignin);
        	}
        });

        self.openMsSignUpPage = function(){
            var href = $('.thyHeaderLink.header-ms-singup').attr('href');
            if(href)
                window.location = href;
        };

        $(document).on('contentReady', function () {
            if ($('.fb-like').length && !window.socialLinks) {
                $('body').append('<script type="text/javascript">require(["social-likes"])</script>');
                window.socialLinks = true;

            }
        });

        $(document).on('click', '.dropdown-modal-closer', function () {
            var link = $(this).closest('.dropdown').find('[data-toggle="dropdown"]');
            link.length && link.trigger('click')
        });

        $(document).on('click', '.popup-close', function () {
            var $this = $(this);
            if ($this.is('.dropdown-modal-closer') || !$this.hasClass('close-modal'))
                return;
            var modal = $(this).closest('.popup'),
                link = $('[href="#' + modal.attr('id') + '"]');
            link.length && link.trigger('click')
        });

        /** Header signin modal code  **/
        $(document).on('click', '#headerSigninModal', function () {
            Eteration.loadStaticFragment({
                app: 'app.ms',
                module: 'login',
                el: $('#siginModalContainer'),
                success: function () {
                    $('#signinModal').modal("show");
                    ko.applyBindings(new loginView.ViewModel(function () {
                    }), $("#siginModalContainer")[0]);
                }
            });
        });

        function checkCookieStatus() {
            if (cookieHelper.getCookie("COOKIE_FUNCTIONAL")==='true') {
                $('#functionalCookies').attr('checked','true');
            }else{
                $('#functionalCookies').removeAttr('checked');
            }
            if (cookieHelper.getCookie("COOKIE_ADVERTISEMENTS")==='true') {
                $('#advertisementsCookies').attr('checked','true');
            }else{
                $('#advertisementsCookies').removeAttr('checked');
            }
            if (cookieHelper.getCookie("COOKIE_ANALYTICS")==='true') {
                $('#analyticsCookies').attr('checked','true');
            }else{
                $('#analyticsCookies').removeAttr('checked');
            }

            $('#cookieWarningOptionmodalConfirm').click(function(e){
                cookieHelper.setCookie("COOKIE_WARNING_VIEWED", "true", 5000, true);
                $('#cookieWarningMessageNew').hide();
                $('#cookieWarningOptionmodal').hide();
                $('#cookieWarningOverlay').hide();
            });
        }

        $(document).on('click', '#cookieWarningOptionChangeId', function () {
            checkCookieStatus();
        });

        $(document).on('click', '.cookieWarning-customCatch, .cookieWarnin-link', function () { //catch button click on static pages
            $('#cookieWarningOptionmodal').modal("show");
            $('header').css("z-index", "1072");
            checkCookieStatus();
        });

        // Cookies switch checkbox
        $(document).on('click','div .switch',function(){

            var inputSwitch=$(this).find('input.cookie-switch-input');
            if(inputSwitch.prop('checked')){
                inputSwitch.removeAttr('checked');
                if(inputSwitch.prop('id')==='functionalCookies'){
                    cookieHelper.setCookie("COOKIE_FUNCTIONAL", "false", 5000, true);
                    //BACKEND INFO FOR COOKIE_ADVERTISEMENTS IS TRUE
                }else if(inputSwitch.prop('id')==='advertisementsCookies'){
                    cookieHelper.setCookie("COOKIE_ADVERTISEMENTS", "false", 5000, true);
                    //BACKEND INFO FOR COOKIE_ADVERTISEMENTS IS TRUE
                }else if(inputSwitch.prop('id')==='analyticsCookies'){
                    cookieHelper.setCookie("COOKIE_ANALYTICS", "false", 5000, true);
                    //BACKEND INFO FOR COOKIE_ANALYTICSS IS TRUE
                }
            }else{
                inputSwitch.attr('checked','true');
                if(inputSwitch.prop('id')==='functionalCookies'){
                    cookieHelper.setCookie("COOKIE_FUNCTIONAL", "true", 5000, true);
                    //BACKEND INFO FOR COOKIE_ADVERTISEMENTS IS TRUE
                }else if(inputSwitch.prop('id')==='advertisementsCookies'){
                    cookieHelper.setCookie("COOKIE_ADVERTISEMENTS", "true", 5000, true);
                    //BACKEND INFO FOR COOKIE_ADVERTISEMENTS IS TRUE
                }else if(inputSwitch.prop('id')==='analyticsCookies'){
                    cookieHelper.setCookie("COOKIE_ANALYTICS", "true", 5000, true);
                    //BACKEND INFO FOR COOKIE_ANALYTICSS IS TRUE
                }
            }

        });

        function removeExtraModalBackdrops() {
            var modalBackdrops = $(".modal-backdrop");
            if (modalBackdrops.length > 1) {
                modalBackdrops.not(':first').remove();
            }
        }

        $(document).ready(function () {
            var body = $('body');
            var modalOpen = 'modal-open'

            $(document)
                .on("shown.bs.modal", removeExtraModalBackdrops)
                .on("hidden.bs.modal", function (){
                    body.removeClass(modalOpen);
                    removeExtraModalBackdrops();
                });
        });

        var checkCookiesSetToSwitch = function(){
            var functionalCookiesElement=$('#functionalCookies');
            var advertisementsCookiesElement=$('#advertisementsCookies');
			var analyticsCookiesElement = $('#analyticsCookies');
            if (!cookieHelper.getCookie("COOKIE_FUNCTIONAL")) {
                cookieHelper.setCookie("COOKIE_FUNCTIONAL", "true", 5000, true);
                //BACKEND INFO FOR COOKIE_ADVERTISEMENTS IS TRUE
                functionalCookiesElement.attr('checked','true');
            }else if(cookieHelper.getCookie("COOKIE_FUNCTIONAL")==='true'){
                functionalCookiesElement.attr('checked','true');
            }else if(cookieHelper.getCookie("COOKIE_FUNCTIONAL")==='false'){
                functionalCookiesElement.removeAttr('checked');
            }else if(cookieHelper.getCookie("COOKIE_ANALYTICS")==='true'){
                analyticsCookiesElement.attr('checked','true');
            }else if(cookieHelper.getCookie("COOKIE_ANALYTICS")==='false'){
                analyticsCookiesElement.removeAttr('checked');
            }

            if (!cookieHelper.getCookie("COOKIE_ADVERTISEMENTS")) {
                cookieHelper.setCookie("COOKIE_ADVERTISEMENTS", "true", 5000, true);
                //BACKEND INFO FOR COOKIE_ADVERTISEMENTS IS TRUE
                advertisementsCookiesElement.attr('checked','true');
            }else if(cookieHelper.getCookie("COOKIE_FUNCTIONAL")==='true'){
                functionalCookiesElement.attr('checked','true');
            }else if(cookieHelper.getCookie("COOKIE_FUNCTIONAL")==='false'){
                functionalCookiesElement.removeAttr('checked');
            }else if(cookieHelper.getCookie("COOKIE_ANALYTICS")==='true'){
                analyticsCookiesElement.attr('checked','true');
            }else if(cookieHelper.getCookie("COOKIE_ANALYTICS")==='false'){
                analyticsCookiesElement.removeAttr('checked');
            }

            if (!cookieHelper.getCookie("COOKIE_ANALYTICS")) {
                cookieHelper.setCookie("COOKIE_ANALYTICS", "true", 5000, true);
                //BACKEND INFO FOR COOKIE_ADVERTISEMENTS IS TRUE
                analyticsCookiesElement.attr('checked','true');
            }else if(cookieHelper.getCookie("COOKIE_ADVERTISEMENTS")==='true'){
                advertisementsCookiesElement.attr('checked','true');
            }else if(cookieHelper.getCookie("COOKIE_ADVERTISEMENTS")==='false'){
                advertisementsCookiesElement.removeAttr('checked');
            }else if(cookieHelper.getCookie("COOKIE_FUNCTIONAL")==='true'){
                functionalCookiesElement.attr('checked','true');
            }else if(cookieHelper.getCookie("COOKIE_FUNCTIONAL")==='false'){
                functionalCookiesElement.removeAttr('checked');
            }
        };
        var checkCookiesSwitchCheckbox=function(counter){
            counter++;
            if($('.cookie-switch-input').length>0){
                checkCookiesSetToSwitch();
            }else{
                if(counter<10){
                    checkCookiesSwitchCheckbox(counter);
                }
            }
        };
        checkCookiesSwitchCheckbox(0);
        if (window.isPhoneOrTablet) {
            require(['app/ko-app-mobile']);
        }


        require(['app/ko-app-touch']);
    }
);
